module.exports = __webpack_public_path__ + "static/img/关于我们_图6@2x.372e8d21.png";